import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = (theme) => ({
  px: 2,
  py: 1.5,
  borderRadius: "16px",
  display: "flex",
  flexDirection: "column",
  gap: 1,
  backgroundColor: theme.palette.quizPopap.quizBg,
  border: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
  color: theme.palette.quizPopap.quizText,
});

export const rowStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexWrap: "wrap",
};

export const iconStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#D4A017",
  flexShrink: 0,
};

export const textStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 600,
};

export const separatorStyle: SxProps<Theme> = {
  width: 4,
  height: 4,
  borderRadius: "50%",
  backgroundColor: "rgba(15, 23, 42, 0.28)",
  flexShrink: 0,
};

export const metaRowStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 0.75,
};

export const metaTextStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 500,
  opacity: 0.82,
};
